import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorIcon from "@mui/icons-material/Close";
import { PRIMARY_COLOR, RED_COLOR } from "../../utils/color-const";
import { GOLDEN_RATIO } from "../../utils/style-const";

const OuterDiv = styled('div')({
  position: 'relative',
});

const InnerDiv = styled('div')({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  WebkitTransform: 'translate(-50%, -50%)',
});

const IconDiv = styled(InnerDiv)({
  animation: '250ms fade-in',
});

const ErrorDiv = styled('div')({
  animation: '250ms fade-in',
});

const Spinner = ({ size = 40, error }) => (
  <div>
    <OuterDiv style={{ height: size }}>
      <InnerDiv>
        <CircularProgress
          style={{ color: error ? RED_COLOR : PRIMARY_COLOR }}
          variant={error ? "determinate" : "indeterminate"}
          value={error ? 100 : 0}
        />
      </InnerDiv>
      {error && (
        <IconDiv>
          <ErrorIcon style={{ color: RED_COLOR, fontSize: size * GOLDEN_RATIO }} />
        </IconDiv>
      )}
    </OuterDiv>
    {error && typeof error !== "boolean" && (
      <ErrorDiv>
        <span style={{ color: RED_COLOR }}>{error}</span>
      </ErrorDiv>
    )}
  </div>
);

Spinner.propTypes = {
  size: PropTypes.number,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
};

export default Spinner;
